module.exports = __webpack_public_path__ + "img/clustering.b163e01d.png";